var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slide-content"},[_c('img',{class:_vm.imageStyles,attrs:{"src":_vm.slideImageUrl,"alt":_vm.imageText}}),_c('div',{staticClass:"carousel flex justify-content--center"},_vm._l((_vm.images),function(image,index){return _c('div',{key:index,staticClass:"carousel__point",class:{
        'carousel__point--current': _vm.getIsCurrentSlide(index),
        'carousel__point--previous': !_vm.getIsCurrentSlide(index)
      },on:{"click":function($event){return _vm.selectSlide(index)}}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }